import { createClass } from "asteroid";
//import { setLoggedUser, unsetLoggedUser } from '../components/Login/LoginActions';

const Asteroid = createClass();
// Connect to a Meteor backend
const asteroid = new Asteroid({
  //Para probar en servidor en localhost
  // endpoint: 'ws://localhost:3000/websocket',

  //para probar en server e produccion
  //endpoint: 'ws://AloMeteorLB-708281795.us-east-2.elb.amazonaws.com/websocket'

  //para probar en server de desarrollo
  // endpoint: 'ws://AloSeguroLBDEV-933021497.us-west-2.elb.amazonaws.com/websocket' //DESARROLLO

  //Produccion Unity Server AWS
  //endpoint: 'ws://AloSeguroLB-896255326.us-west-2.elb.amazonaws.com/websocket'
  //endpoint: 'wss://AloSeguroLB-896255326.us-west-2.elb.amazonaws.com/websocket'
  endpoint: "wss://server.aloseguro.com/websocket", //PRODUCCION
  //endpoint: "wss://dev-server.aloseguro.com/websocket"
});

console.log("Actual End Point:", asteroid.endpoint);
console.log("1.30");
// if you want realitme updates in all connected clients
// subscribe to the publication
//asteroid.subscribe('todo');
//asteroid.subscribe('user');

export default asteroid;



// WEBPACK FOOTER //
// ./common/asteroid.js